import type { InjectionKey } from "vue";

/**
 * Onde o Modal/Drawer se teleportam. O painel não diz nada (vai ao `body`); a tela
 * sob medida dá a camada do pedaço VISÍVEL da moldura — a moldura cresce até a
 * altura do conteúdo, e um `fixed` no `body` dela ficaria fixo na tela inteira.
 */
export const OVERLAY_TARGET: InjectionKey<string | HTMLElement> = Symbol("overlay-target");
